import { Navigate, Outlet, Link } from 'react-router-dom'
import { usePlatformStore } from '@/stores/platform.store'
import { Button, ToastContainer } from '@/components/ui'
import { usePlatformHydrated } from '@/hooks/usePlatformHydrated'

export function PlatformLayout() {
  const token = usePlatformStore((s) => s.token)
  const clearToken = usePlatformStore((s) => s.clearToken)
  const hydrated = usePlatformHydrated()

  if (!hydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 text-gray-400">
        Загрузка…
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/platform/login" replace />
  }

  return (
    <div className="flex min-h-screen flex-col bg-gray-50 text-gray-900">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
          <div>
            <Link to="/platform" className="text-lg font-semibold text-gray-900 hover:text-gray-700">
              TrueMark Platform
            </Link>
            <p className="text-xs text-gray-500">Оператор SaaS — кабинеты клиентов</p>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/login" className="text-sm text-gray-500 hover:text-gray-900">
              Вход клиента
            </Link>
            <Button variant="ghost" size="sm" onClick={clearToken}>
              Выйти
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl flex-1 px-6 py-6">
        <Outlet />
      </main>
      <ToastContainer />
    </div>
  )
}
